import { render, staticRenderFns } from "./list-pv-approval.vue?vue&type=template&id=25ab0f0e&"
import script from "./list-pv-approval.vue?vue&type=script&lang=js&"
export * from "./list-pv-approval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports